import { Sentry } from '../sentry';

const TRANSIENT_NETWORK_MESSAGES = [
  'Failed to fetch',
  'NetworkError when attempting to fetch resource',
  'Load failed',
];

function isTransientNetworkError(error) {
  return (
    error?.name === 'TypeError' &&
    TRANSIENT_NETWORK_MESSAGES.some((msg) => error.message?.includes(msg))
  );
}

export function captureNetworkError(error, context = {}) {
  if (!Sentry || error?.name === 'AbortError' || isTransientNetworkError(error))
    return;
  Sentry.captureException(error, { tags: { source: 'network', ...context } });
}

export function captureClientError(error, context = {}) {
  if (!Sentry || error?.name === 'AbortError') return;
  Sentry.captureException(error, { tags: { source: 'client', ...context } });
}
